import { Request } from '~src/httpClient/serverApi/requests/Request';
import { IResult } from '~src/httpClient/serverApi/types/IResponse';

export interface IUpdateConnectionUsingRemoteQueryAgentParams {
  ids: string[];       // Data source ids
  usingRemoteQueryAgent: boolean;
}

export class UpdateConnectionUsingRemoteQueryAgentRequest extends Request<IUpdateConnectionUsingRemoteQueryAgentParams, IResult> {
  constructor(params: IUpdateConnectionUsingRemoteQueryAgentParams) {
    super('updateConnectionUsingRemoteQueryAgent', params);
  }
}
